// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__6Vjvz","inputWrap":"styles_inputWrap__Qc2FG","input":"styles_input__2arBp"};